import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import PublicLayout from "@/components/public/PublicLayout";
import ShopGate from "@/components/public/ShopGate";
import Home from "@/pages/public/Home";
import Prestations from "@/pages/public/Prestations";
import ServiceDetail from "@/pages/public/ServiceDetail";
import Realisations from "@/pages/public/Realisations";
import RealisationDetail from "@/pages/public/RealisationDetail";
import Actualites from "@/pages/public/Actualites";
import ZoneIntervention from "@/pages/public/ZoneIntervention";
import Conseils from "@/pages/public/Conseils";
import ArticleDetail from "@/pages/public/ArticleDetail";
import Contact from "@/pages/public/Contact";
import Entreprise from "@/pages/public/Entreprise";
import MentionsLegales from "@/pages/public/MentionsLegales";
import Confidentialite from "@/pages/public/Confidentialite";
import Boutique from "@/pages/public/Boutique";
import ProductDetail from "@/pages/public/ProductDetail";
import Panier from "@/pages/public/Panier";
import Confirmation from "@/pages/public/Confirmation";
import Compte from "@/pages/public/Compte";

import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import RealisationsAdmin from "@/pages/admin/RealisationsAdmin";
import SeoTools from "@/pages/admin/SeoTools";
import Leads from "@/pages/admin/Leads";
import LiveChat from "@/pages/admin/LiveChat";
import Keywords from "@/pages/admin/Keywords";
import Staff from "@/pages/admin/Staff";
import Sessions from "@/pages/admin/Sessions";
import Settings from "@/pages/admin/Settings";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import Orders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import AbandonedCarts from "@/pages/admin/AbandonedCarts";
import Customers from "@/pages/admin/Customers";
import AccountRequests from "@/pages/admin/AccountRequests";
import SavTickets from "@/pages/admin/SavTickets";
import Fleet from "@/pages/admin/Fleet";
import Logistics from "@/pages/admin/Logistics";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
        <CustomerAuthProvider>
        <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/prestations" element={<Prestations />} />
            <Route path="/prestations/:slug" element={<ServiceDetail />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/realisations/:slug" element={<RealisationDetail />} />
            <Route path="/actualites" element={<Actualites />} />
            <Route path="/zone-intervention" element={<ZoneIntervention />} />
            <Route path="/conseils" element={<Conseils />} />
            <Route path="/conseils/:slug" element={<ArticleDetail />} />
            <Route path="/entreprise" element={<Entreprise />} />
            <Route path="/boutique" element={<ShopGate><Boutique /></ShopGate>} />
            <Route path="/boutique/panier" element={<ShopGate><Panier /></ShopGate>} />
            <Route path="/boutique/confirmation" element={<ShopGate><Confirmation /></ShopGate>} />
            <Route path="/boutique/:slug" element={<ShopGate><ProductDetail /></ShopGate>} />
            <Route path="/compte" element={<Compte />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="realisations" element={<RealisationsAdmin />} />
            <Route path="produits" element={<ProductsAdmin />} />
            <Route path="commandes" element={<Orders />} />
            <Route path="commandes/:orderId" element={<OrderDetail />} />
            <Route path="paniers-abandonnes" element={<AbandonedCarts />} />
            <Route path="clients" element={<Customers />} />
            <Route path="comptes-pro" element={<AccountRequests />} />
            <Route path="seo" element={<SeoTools />} />
            <Route path="leads" element={<Leads />} />
            <Route path="sav" element={<SavTickets />} />
            <Route path="flotte" element={<Fleet />} />
            <Route path="logistique" element={<Logistics />} />
            <Route path="chat" element={<LiveChat />} />
            <Route path="keywords" element={<Keywords />} />
            <Route path="staff" element={<Staff />} />
            <Route path="connexions" element={<Sessions />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
        </CustomerAuthProvider>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
